<template>
  <div :style="boxHeight" class="booked-container">
    <div class="booked-info">
      <CancelSession
        v-if="!userIsMatchedForSlot"
        :userID="userID"
        :boxHeight="boxHeight"
        :quickCancel="true"
        :slotTimeString="slotTimeString"
        :currentUserData="currentUserData"
        :slotDateTimeMS="slotDateTimeMS"
        @cancelSession="cancelSession"
        @exitIsCanceling="exitIsCanceling"
        parentName="UserSession"
      />
      <span class="booked-time">{{ slotTimeString }}</span>
      <a :href="`/profile/${partnerID}`" v-if="userIsMatchedForSlot" class="partner-details">
        <ik-image loading="lazy" :transformation="[{ height: 60, width: 60 }]" v-if="partnerImageUrl" :src="partnerImageUrl" class="partner-image" />
        <div v-else class="partner-image smallBorder">
          <IconBase icon-name="profile" iconColor="#444" viewBox="0 0 32 32" width="100%" height="100%" strokeWidth="0px"><IconProfileImg /></IconBase>
        </div>
        <div class="booked-title">{{ `${partnerName}` }}</div>
      </a>
<!--       <a :href="sessionLink" v-if="minutesToNextSession < 10 && slotDateTimeMS == nextMatchDateTimeMS" class="join-session">
        Join
      </a> -->
      <!-- Href to support full reload for ads -->
      <a :href="sessionLink" v-if="minutesToNextSession < 10 && slotDateTimeMS == nextMatchDateTimeMS" class="join-session">Join</a>
      <div v-if="userIsMatchedForSlot">
        <div class="selected-close" @click="setIsCanceling">x</div>
      </div>
      <span v-else class="booked-title-unmatched">Not yet matched... </span>
    </div>
  </div>
</template>

<script>
import CancelSession from "./CancelSession";
import IconBase from "../../../../components/IconBase";
import IconProfileImg from "../../../../components/SVG/IconProfileImg";

export default {
  name: "UserSession",
  props: ["boxHeight", "slotTimeString", "slotDateTimeMS", "userID", "userIsMatchedForSlot", "sessionLink", "partnerData", "nextMatchDateTimeMS", "currentUserData", "minutesToNextSession"],
  components: {
    CancelSession,
    IconBase,
    IconProfileImg,
  },
  computed: {
    partnerID: function() {
      return this.partnerData ? this.partnerData.partnerID : null;
    },
    partnerName: function() {
      return this.partnerData ? this.partnerData.partnerName : null;
    },
    partnerImageUrl: function() {
      return this.partnerData ? this.partnerData.partnerProfileImageUrl : null;
    },
  },
  methods: {
    setIsCanceling() {
      this.$emit("setIsCanceling", {
        dateTimeMS: this.slotDateTimeMS,
        value: true,
      });
    },

    cancelSession(dateTimeMS, userID) {
      this.$emit("cancelSession", dateTimeMS, userID);
    },
    exitIsCanceling(dateTimeMS) {
      this.$emit("exitIsCanceling", dateTimeMS);
    },
  },
};
</script>
<style scoped>
@import "../styles/SessionBox.css";
</style>
